import React from "react";
import BetterAlerts from "../BetterAlerts";
import BetterBox from "../BetterBox";
import { Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";

export default function InsertEmail({ errors, submitted, handleChange, handleSubmit }) {
	return (
		<div>
			<div className="col-sm-12">
				<BetterAlerts errors={errors} />
			</div>

			<div>
				<div className="col-sm-12">
					<BetterBox title="Digite um e-mail." subtitle="Se o e-mail existir no sistema será enviado um link de redefinição de senha.">
						<div className="col-sm-12">
							<div className="form-group fg-line">
								<TextField type="email" name="email" label="E-mail *" margin="normal" variant="outlined" onBlur={handleChange} onChange={handleChange} />
							</div>
						</div>
					</BetterBox>
				</div>

				<div className="col-sm-12">
					<div className="d-flex justify-content-between">
						<Button style={{ fontWeight: 400 }} disabled={submitted} variant="secondary" onClick={() => { window.location.href = "/auth/login" }}>
							Voltar
						</Button>

						<Button disabled={submitted} className="btn btn-primary btn-lg btn-bold tt-14" onClick={handleSubmit}>
							<i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Enviar
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}